module.exports = __webpack_public_path__ + "media/images/brand/logo-reverse-2026-9a6f67e5045a8384a9eaa6caee9e8f77.svg";